import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Spinner from 'shared/components/Spinner';
import Alert from 'shared/components/Alert';
import TranslateError from 'shared/components/TranslateError';

const Loadable = ({
  loading,
  canRender,
  error,
  render,
  screen: Screen,
  splashOnTop,
  noPadding,
  spinnerSize,
  spinnerClassName,
  helmetTitle
}) => {
  if (loading && !error && !canRender) {
    if (Screen && typeof Screen === 'function') {
      return <Screen />;
    }

    if (Screen) {
      return Screen;
    }

    return (<Spinner noPadding={noPadding} spinnerSize={spinnerSize} className={spinnerClassName} />);
  }

  if (error !== null) {
    return (
      <>
        {helmetTitle && (
          <Helmet>
            <title>{helmetTitle}</title>
          </Helmet>
        )}
        <Alert canClose={false} variant="error">
          <TranslateError>{error.error || error.message || error.toString()}</TranslateError>
        </Alert>
      </>
    );
  }

  if (loading && canRender) {
    document.body.classList.add('no-scroll');
    return (
      <>
        {helmetTitle && (
          <Helmet>
            <title>{helmetTitle}</title>
          </Helmet>
        )}
        {Screen || (<Spinner splash top={splashOnTop} className={spinnerClassName} />)}
        {render()}
      </>
    );
  }

  document.body.classList.remove('no-scroll');
  return (
    <>
      {helmetTitle && (
        <Helmet>
          <title>{helmetTitle}</title>
        </Helmet>
      )}
      {render()}
    </>
  );
};

Loadable.propTypes = {
  render: PropTypes.func,
  loading: PropTypes.bool,
  canRender: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  screen: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node]),
  splashOnTop: PropTypes.bool,
  noPadding: PropTypes.bool,
  spinnerSize: PropTypes.number,
  helmetTitle: PropTypes.string,
  spinnerClassName: PropTypes.string,
};

Loadable.defaultProps = {
  render() {
    return null;
  },
  loading: false,
  canRender: false,
  error: null,
  screen: null,
  splashOnTop: false,
  noPadding: false,
  spinnerSize: 80,
  helmetTitle: null,
  spinnerClassName: null,
};

export default Loadable;
